import { useApi } from '#shared/providers/Api';
import useUsers from './useUsers';
import unwrap from './unwrap';

export default function useDeleteUser() {
  const api = useApi();
  const { account } = useUsers();

  function deleteUser(params: { EmailAddress: string }) {
    return unwrap(api.postDeleteAccountUser(params, account.bearer));
  }

  return { deleteUser };
}
